module.exports = __webpack_public_path__ + "img/upload-active.b45d5b1.png";